import request from '../adminRequest'

export const positionTagApi = {
  listPositionTag (params) {
    return request.get('/positionTags', { params: params })
  },
  getPositionTag (id) {
    return request.get('/positionTags/' + id)
  },
  savePositionTag (data) {
    return request.post('/positionTags', data)
  },
  updatePositionTag (id, data) {
    return request.put('/positionTags/' + id, data)
  },
  deletePositionTag (id) {
    return request.delete('/positionTags/' + id)
  },
}

export default positionTagApi
